<script setup>
import {reactive,onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";
const props = defineProps({
  contextIdA: String
});

const data = reactive({
  valid: true,
  dialog: false,
  dialog2: false,
  open: false,
  loading: false,
  edit: false,
  newState: null,
  newLossAmount: null,
  items: [],
  newItem: [],
  tempName: '',
  name: '',
  tempPhone: '',
  phone: '',
  tempStreetAdd: '',
  streetaddress: '',
  tempCity: '',
  city: '',
  tempState: '',
  state: '',
  tempZip: '',
  zip: '',
  tempInvoiceNetTerm: null,
  invoicenet_term: null,
  tempSendAutonotesEmails: null,
  acknowledgements: false,
  tempAcknowledgements: false,
  tempSendAutonotesEmails: null,
  send_autonotes_emails: null,
  tempMessage: '',
  message: '',
  states: [
    'AL',
    'AK',
    'AS',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FM',
    'FL',
    'GA',
    'GU',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MH',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'MP',
    'OH',
    'OK',
    'OR',
    'PW',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VI',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
  ],

});

const cancel = () => {
  data.edit = false
  data.phone = data.tempPhone
  data.name = data.tempName
  data.streetaddress = data.tempStreetAdd
  data.city = data.tempCity
  data.state = data.tempState
  data.zip = data.tempZip
  data.invoicenet_term = data.tempInvoiceNetTerm
  data.message = data.tempMessage
  data.acknowledgements = data.tempAcknowledgements
  data.send_autonotes_emails = data.tempSendAutonotesEmails
}

const formatPhoneNumber = (phoneNumberString) => {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  }
  return null
}

const getData = () => {
  data.loading = true

  ApiWrapper.get('client-info', 'client-info','clientId=' + props.contextIdA)
      .then((response) => {
        if(response.client){
          if(response.client.phone){
            data.phone = response.client.phone
          }
          if(response.client.name){
            data.name = response.client.name
          }
          if(response.client.streetaddress){
            data.streetaddress = response.client.streetaddress
          }
          if(response.client.city){
            data.city = response.client.city
          }
          if(response.client.state){
            data.state = response.client.state
          }
          if(response.client.zip){
            data.zip = response.client.zip
          }
          if(response.client.invoicenet_term) {
            data.invoicenet_term = response.client.invoicenet_term
          }
          if(response.client.clientmessage){
            data.message = response.client.clientmessage
          }
          if(response.client.acknowledgements){
            data.acknowledgements = response.client.acknowledgements
          }
          if(response.client.send_autonotes_emails) {
            data.send_autonotes_emails = response.client.send_autonotes_emails
          }
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.edit = false
        data.loading = false
      })
}

const submit = () => {
  data.loading = true

  //Hack to enforce valid data-type for Knex to update column that can be integer OR null. This is by far ideal, and
  //should really be performing a much more thorough type/value validation (e.g. handle all NaN cases, clean before checks, etc.)
  let _parsedInvoiceNetField = parseInt(data.invoicenet_term, 10);
  let invoiceNetValidType = !isNaN(_parsedInvoiceNetField) &&
      typeof(_parsedInvoiceNetField) == "number" &&
      _parsedInvoiceNetField >= 0;

  if( !invoiceNetValidType )
    data.invoicenet_term = null;

  ApiWrapper.post('client-info', 'edit', {
        phone: data.phone,
        name: data.name,
        streetaddress: data.streetaddress,
        city: data.city,
        state: data.state,
        zip: data.zip,
        send_autonotes_emails: data.send_autonotes_emails,
        invoicenet_term: data.invoicenet_term,
        clientmessage: data.message,
        clientId: props.contextIdA,
        acknowledgements: data.acknowledgements
      })
      .then((response) => {
        getData()
        ToastUtil.successMsg('Updated client');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

onMounted(()=>{
  getData()
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-progress-linear
          :active="data.loading"
          :indeterminate="data.loading"
          absolute
          bottom
          color="primary"
      >
      </v-progress-linear>
      <v-form v-if="data.edit" class="pa-4">

        <v-text-field type="text" label="Client Name" v-model="data.name"></v-text-field>
        <v-textarea label="Client Message" v-model="data.message"></v-textarea>
        <v-text-field type="text" label="Client Phone" v-model="data.phone"></v-text-field>
        <v-text-field type="text" label="Street Address" v-model="data.streetaddress"></v-text-field>
        <v-text-field type="text" label="City" v-model="data.city"></v-text-field>
        <!-- <v-text-field type="text" label="State" v-model="state"></v-text-field> -->
        <v-autocomplete :items="data.states" label="State" v-model="data.state" auto-select-first ></v-autocomplete>
        <v-text-field type="text" label="Zip" v-model="data.zip"></v-text-field>
        <v-text-field type="text" label="Invoice Net" v-model="data.invoicenet_term"></v-text-field>
        <v-switch label="Send Acknowledgements" color="primary" v-model="data.acknowledgements"></v-switch>
        <v-switch label="Auto-Send Notes as Emails" color="primary" v-model="data.send_autonotes_emails"></v-switch>
        <v-card-actions>
          <v-btn size="small" variant="elevated" color="error" @click="cancel">Cancel</v-btn>
          <v-btn size="small" variant="elevated" color="primary" @click="submit">Submit</v-btn>
        </v-card-actions>
      </v-form>

      <div v-else class="pa-0">
        <v-list-item density="compact" class="pr-2 pb-0">
            <v-list-item-subtitle>Client Name</v-list-item-subtitle>
            <v-list-item-title>
              <h2>{{data.name}}</h2>
            </v-list-item-title>
          <v-spacer></v-spacer>

        </v-list-item>
        <v-row density="compact">
          <v-col md="6">
            <div class="pl-4 pt-2">
              <v-list-item-subtitle>Phone</v-list-item-subtitle>
              <v-list-item-title>{{formatPhoneNumber(data.phone)}}</v-list-item-title>
            </div>
            <v-list-item density="compact">
              <v-list-item-subtitle>Client Message</v-list-item-subtitle>
              <v-list-item-title class="text-wrap">{{data.message}}</v-list-item-title>
            </v-list-item>
          </v-col>
          <v-col md="12">
            <v-list-item density="compact">
                <v-list-item-subtitle>Address</v-list-item-subtitle>
                <v-list-item-title>
                  {{data.streetaddress}}
                  <br />
                  {{data.city}} {{data.state}} {{data.zip}}
                </v-list-item-title>
            </v-list-item>
          </v-col>
          <v-col md="12">
            <v-list-item density="compact">
              <v-list-item-title>Invoice Net: {{data.invoicenet_term}}</v-list-item-title>
            </v-list-item>
          </v-col>
          <v-col md="12">
            <v-list-item density="compact">
              <v-list-item-subtitle>Send Acknowledgements</v-list-item-subtitle>
              <v-list-item-title v-if="data.acknowledgements">
                Yes
              </v-list-item-title>
              <v-list-item-title v-else>
                No
              </v-list-item-title>
            </v-list-item>
          </v-col>
          <v-col md="12">
            <v-list-item density="compact">
              <v-list-item-subtitle>Automatically send Client Rep of claim, emails for tasks: Initial Contact, Appointment Set, and Complete Inspection.</v-list-item-subtitle>
              <v-list-item-title v-if="data.send_autonotes_emails">Yes</v-list-item-title>
              <v-list-item-title v-else>No</v-list-item-title>
            </v-list-item>
          </v-col>
        </v-row>

        <v-card-actions density="compact">
          <v-btn
              size="small"
              variant="elevated"
              dark
              color="primary"
              v-if="Permissions.checkPermissions(['clients.update'])"
              @click=
              "
                data.edit = true;
                data.tempName = data.name;
                data.tempPhone = data.phone;
                data.tempStreetAdd = data.streetaddress;
                data.tempCity = data.city;
                data.tempState = data.state;
                data.tempZip = data.zip;
                data.tempInvoiceNetTerm = data.invoicenet_term;
                data.tempMessage = data.message;
                data.tempAcknowledgements = data.acknowledgements;
                data.tempSendAutonotesEmails = data.send_autonotes_emails;
              "
          >Edit Client
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }

  [v-cloak] {
    display: none;
  }

  h5 {
    font-weight: normal;
    font-family: sans-serif;
  }

  .v-list-item-subtitle {
    font-size: 10px !important;
    color: black !important;
  }
  .v-list-item-title {
    font-size: 13px !important;
    color: black !important;
  }

  .v-card-subtitle {
    color: black !important;
  }
</style>